import { render, staticRenderFns } from "./ExpiredBanner.vue?vue&type=template&id=304dbe0e&scoped=true"
import script from "./ExpiredBanner.vue?vue&type=script&lang=js"
export * from "./ExpiredBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304dbe0e",
  null
  
)

export default component.exports